"use client";
import useLenis from "@/hooks/useLenis";
import useSetBackgorund from "@/hooks/useSetBackgorund";
import Preloader from "@/components/ui/preloader";
import CookieManager from "@/components/CookieManager";
import { ModalProvider, useModalContext } from "@/contexts/ModalContext";
import ThankYouModal from "@/components/common/thank-you-modal";
import { useEffect } from "react";

// Optimized Bootstrap loading
const loadBootstrap = async () => {
    if (typeof window !== "undefined") {
        try {
            await import("bootstrap");
        } catch (error) {
            console.warn("Bootstrap failed to load:", error);
        }
    }
};

const ModalWrapper = ({ children }: { children: React.ReactNode }) => {
    const modal = useModalContext();
    
    return (
        <>
            {children}
            <ThankYouModal 
                isOpen={modal.isThankYouModalOpen} 
                onClose={modal.closeThankYouModal} 
            />
        </>
    );
};

const Providers = ({
    children,
}: Readonly<{
    children: React.ReactNode;
}>) => {
    useLenis();
    useSetBackgorund();

    // Load Bootstrap after initial render
    useEffect(() => {
        loadBootstrap();
    }, []);

    return (
        <ModalProvider>
            <ModalWrapper>
                {/* preloader start */}
                <Preloader />
                {/* preloader end */}
                {children}
                {/* cookie consent system */}
                <CookieManager />
            </ModalWrapper>
        </ModalProvider>
    );
};

export default Providers;
